export default __webpack_public_path__ + "static/media/video-thumb.eaff3b17.png";